import { render, staticRenderFns } from "./GameMenu.vue?vue&type=template&id=8b88c84e&scoped=true&"
import script from "./GameMenu.vue?vue&type=script&lang=js&"
export * from "./GameMenu.vue?vue&type=script&lang=js&"
import style0 from "./GameMenu.vue?vue&type=style&index=0&id=8b88c84e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b88c84e",
  null
  
)

export default component.exports